<template>
  <MultiSelect
    filter
    display="chip"
    unstyled
    :placeholder="placeholder"
    :pt="{
      root: ({ state }) => ({
        class: [
          'rounded px-2 py-1 flex flex-row justify-between w-full',
          disabled ? disabledClass:'bg-white dark:bg-slate-700',
          state.focused ? focusClass:'',
          transitionClass,
          borderClass,
          paddingClass
        ]
      }),
      item: ({ context }) => ({
        class: [
          textClass,
          'flex flex-row px-2 py-[2px] transition-all last:rounded-b',
          context.selected ? 'bg-theme/20 hover:bg-theme/40':'hover:bg-gray-500/10'
        ]
      }),
      label: ({ props }) => ({
        class: [
          'outline-0 w-full flex flex-row flex-wrap gap-2 italic text-default/60',
          props.modelValue && props.modelValue.length > 0 ? '':placeHolderClass
        ]
      }),
      header: {
        class: [
          'flex flex-row gap-x-2 p-2'
        ]
      },
      panel: {
        class: panelClass
      },
      token: {
        class: [
          'not-italic rounded-full bg-theme/80 text-white text-sm flex flex-row items-center gap-x-1 px-1 py-0.5'
        ]
      },
      filterContainer: {
        class: [
          'flex flex-row items-center w-full'
        ]
      },
      filterInput: {
        class: [
          'rounded outline-0 w-full px-2 py-1 dark:bg-slate-600',
          borderClass
        ]
      },
    }"
  >
    <template #empty>
      <div :class="emptyText ? 'w-full text-center p-2':''">
        {{ emptyText }}
      </div>
    </template>
    <template #itemcheckboxicon><div></div></template>
    <template #filtericon><div></div></template>
  </MultiSelect>
</template>

<script>

import MultiSelect from 'primevue/multiselect';

export default {
  name: "RpmMultiselectInput",
  components: {
    MultiSelect
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    transitionClass: {
      type: String,
      default: ''
    },
    focusClass: {
      type: String,
      default: ''
    },
    borderClass: {
      type: String,
      default: ''
    },
    textClass: {
      type: String,
      default: ''
    },
    paddingClass: {
      type: String,
      default: ''
    },
    placeHolderClass: {
      type: String,
      default: ' '
    },
    placeholder: {
      type: String,
      default: ' '
    },
    emptyText: {
      type: String,
      default: ''
    },
    panelClass: {
      type: String,
      default: ''
    },
    disabledClass: {
      type: String,
      default: ''
    },
  }
};

</script>
